import React, { useState } from 'react';
import { CardBody,  Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {connect, useSelector} from "react-redux";

import { useForm } from "react-hook-form";
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import {FL_CODE, FL_ONLY_REGISTERED, FL_VALUE} from "../../../components/i18n/formLabels";
import {PH_SEARCH_CODE, PH_SEARCH_VALUE} from "../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

const LabelFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data;

    const [onlyRegistered, setOnlyRegistered] = useState(!props.generalPropouse);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            code: filter?.code ,
            nameSearch: filter?.nameSearch
        }
    });

    const onSubmit = (data, _) => {

        let dataFilter = {};

        if (props.generalPropouse) {
            dataFilter = {
                item :  {
                    ...data
            }
        };
        } else {
            dataFilter = {
                onlyRegistered : onlyRegistered,
                fbDataBase : { id : app?.fbDataBase?.id },
                item :  {
                    ...data
                }
            };
        }

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_SEARCH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_VALUE}</Label>
                            <Input
                                type="text"
                                name="nameSearch"
                                placeholder={PH_SEARCH_VALUE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    {
                        !props.generalPropouse && <Col md="3">
                            <FormGroup>
                                <Label>{ FL_ONLY_REGISTERED }</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={onlyRegistered}
                                    onChange={ () => setOnlyRegistered(!onlyRegistered) }
                                />
                            </FormGroup>
                        </Col>
                    }

                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(LabelFilters)